import * as http from "./http";
import { ApiResponse, ListSort, PaginatedApiResponse } from "../models";
import ApiService from "./service";
import { SearchProjectZonesLocations } from "../models/global-search";
import { Dict } from "../..";
import { Project } from "../models/project";
import { Property } from "../models/property";

export class SearchService extends ApiService {
  public async searchInline(data: {
    query?: string;
    cityId?: string;
    locationIds?: string[];
    zoneId?: string;
  }): Promise<ApiResponse<SearchProjectZonesLocations>> {
    const url = `${this.apiDomain}/api/project/search-inline`;

    const response = await http.post<ApiResponse<SearchProjectZonesLocations>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getProjectList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<ApiResponse<Project[]>> {
    const url = `${this.apiDomain}/api/project/search-all`;
    const response = await http.post<ApiResponse<Project[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getPropertyList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<ApiResponse<Property[]>> {
    const url = `${this.apiDomain}/api/property/search-all`;
    const response = await http.post<ApiResponse<Property[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getDeveloperList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<ApiResponse<Project[]>> {
    const url = `${this.apiDomain}/api/project/search-by-developer`;
    const response = await http.post<ApiResponse<Project[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getLocationSuggestions(data: {
    projectLongitude?: string;
    projectLatitude?: string;
    city?: string;
  }): Promise<any[]> {
    const url = `${this.apiDomain}/api/project/location-suggestions`;

    const response = await http.post<ApiResponse<any[]>>(url, data, this.store);

    return response?.data?.data;
  }

  public async searchDevelopers(data: { query: string }) {
    const url = `${this.apiDomain}/api/developer/search`;
    const response = await http.post<ApiResponse<any[]>>(url, data, this.store);
    return response?.data?.data;
  }
}
